import { jwtDecode, JwtPayload } from 'jwt-decode';

export interface TokenPayload extends JwtPayload {
  [key: string]: unknown;
}

export function getDecodedAccessToken(token?: string): TokenPayload | null {
  if (!token || token.trim() === '') {
    return null;
  }

  try {
    const decodedToken = jwtDecode<TokenPayload>(token);

    if (
      decodedToken &&
      typeof decodedToken === 'object' &&
      'mx-appid' in decodedToken
    ) {
      const { 'mx-appid': _, ...tokenWithoutAppId } = decodedToken;
      return tokenWithoutAppId;
    }
    return decodedToken;
  } catch {
    return null;
  }
}
